import { render } from "./Dashboard.vue?vue&type=template&id=22ba47ca"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "22ba47ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ba47ca', script)) {
    api.reload('22ba47ca', script)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=22ba47ca", () => {
    api.rerender('22ba47ca', render)
  })

}

script.__file = "src/views/Dashboard.vue"

export default script